/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module CoreModule
 */

import {
    Pipe,
    PipeTransform,
} from '@angular/core';

import { GslbLeaderChangeState } from 'generated-types';

/**
 * @description Pipe for returning color based on GSLB Site State.
 * @author Shahab Hashmi
 */
@Pipe({
    name: 'siteStateColor',
})
export class SiteStateColorPipe implements PipeTransform {
    // eslint-disable-next-line class-methods-use-this
    public transform(state: GslbLeaderChangeState | string): string {
        switch (state) {
            case GslbLeaderChangeState.GSLB_LC_STATE_UNAVAILABLE:
            case GslbLeaderChangeState.GSLB_LC_STATE_DISABLED:
                return 'danger';

            case GslbLeaderChangeState.GSLB_LC_STATE_MONITORING:
            case GslbLeaderChangeState.GSLB_LC_STATE_COMPLETED:
            case GslbLeaderChangeState.GSLB_LC_STATE_INIT:
            case GslbLeaderChangeState.GSLB_LC_STATE_IN_PROGRESS:
                return 'success';

            default:
                return '';
        }
    }
}
